import { render } from "./wind.vue?vue&type=template&id=0f833782&scoped=true"
import script from "./wind.vue?vue&type=script&lang=js"
export * from "./wind.vue?vue&type=script&lang=js"

import "./wind.vue?vue&type=style&index=0&id=0f833782&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f833782"]])

export default __exports__